import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
// import { Input } from "components/forms/TwoColContactUsWithIllustrationFullForm";
import Select, { components } from "react-select";
import ReactCountryFlag from "react-country-flag";

const Wrapper = styled.div`
  ${tw`flex items-start flex-col gap-2 mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`}
`;

const StyledSelect = styled(Select)`
  width: 100%;
`;
const { Option } = components;

const IconOption = ({ country, hasIcon, data, ...props }) => {
  return (
    <Option data={data} {...props}>
      {hasIcon ? (
        <>
          {country ? (
            <ReactCountryFlag
              style={{ marginRight: "1rem" }}
              countryCode={data.value}
              svg
            />
          ) : null}
        </>
      ) : null}
      {data.label}
    </Option>
  );
};

/** <img
      src={require("./" + props.data.icon)}
      style={{ width: 36 }}
      alt={props.data.label}
    />  */
const SelectComp = ({
  label,
  optionsArr,
  isDisabled,
  isLoading,
  isClearable,
  isRtl,
  isSearchable,
  hasIcon,
  country,
  getSelection,
  optionsLimit,
  loadOnScroll,
}) => {
  const [limitedOptions, setLimitedOptions] = React.useState([]);
  React.useEffect(() => {
    setLimitedOptions(optionsArr.slice(0, optionsLimit - 1));
  }, [optionsArr]);
  const appendOnScrollHandler = (e) => {
    // take length of limitedoptions -> go to optionsarray[length] and append the next (options limit) number of items into the limited options
    // limitedOptions.length
    let temp = [
      ...limitedOptions,
      ...optionsArr.slice(
        limitedOptions.length,
        limitedOptions.length + optionsLimit
      ),
    ];
    setLimitedOptions(temp);
  };

  return (
    <Wrapper>
      <>{label}</>
      <StyledSelect
        components={{
          Option: (params) => (
            <IconOption country={country} hasIcon={hasIcon} {...params} />
          ),
        }}
        onMenuScrollToBottom={appendOnScrollHandler}
        width="100%"
        className="basic-single"
        styles={{
          valueContainer: (baseStyles) => ({
            ...baseStyles,
            paddingLeft: 0,
            paddingRight: 0,
          }),
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderWidth: 0,
          }),
          indicatorSeparator: (baseStyles) => ({
            ...baseStyles,
            display: "none",
          }),
        }}
        classNamePrefix="select"
        // cacheOptions
        onKeyDown={(e) => {
          console.log(e.target.value);
        }}
        onChange={(e) => {
          getSelection(e.value);
        }}
        label={label}
        defaultValue={optionsArr[0]}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        isRtl={isRtl}
        isSearchable={isSearchable}
        name="color"
        options={loadOnScroll ? limitedOptions : optionsArr}
      />
    </Wrapper>
  );
};
/**[...optionsArr.slice(0, optionsLimit - 1)] */
SelectComp.defaultProps = {
  loadOnScroll: false,
  hasIcon: false,
  country: true,
  label: "Choose a car",
  isDisabled: false,
  isLoading: false,
  isClearable: false,
  isRtl: false,
  isSearchable: true,
  optionsLimit: 10,
  getSelection: (e) => {
    return;
  },
  optionsArr: [
    {
      value: "",
      label: "Select a value",
      isDisabled: true,
    },
    { value: "toyota-corolla", label: "Toyota Corolla" },
    { value: "suzuki-mehran", label: "Suzuki Mehran" },
  ],
};

export default SelectComp;
